import { useTranslation } from "react-i18next";
import { Typography, Breadcrumbs, Link } from "@mui/material";
import { Api } from "queries/types";

const BreadCrumbShop = ({ shop, label }: { shop: Api.Shop | undefined, label: string}) => {
  const { t } = useTranslation();
  if (!shop) return null;
  const { erpId } = shop;

  return <Breadcrumbs aria-label={t("a11y.breadcrumb")} sx={{ maxWidth: '100%', mb: 1, marginLeft: 0 }}>
    <Link underline="always" color="inherit" href={`/shops/${erpId}/edit`}>
      {erpId}
    </Link>
    <Typography color="text.primary" aria-current="page">{t(label)}</Typography>
  </Breadcrumbs>;
};

export default BreadCrumbShop;
